import styles from './MailmagazineCompleted.module.scss'
import Column from 'components/home/Column'
import BottomSlider from 'components/commons/BottomSlider/BottomSlider'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'
import Button from 'components/commons/Button/Button'

const MailmagazineCompleted: React.FC = () => {
  return (
    <article className={styles.main}>
      <section className={styles.content}>
        <div className={styles.inner}>
          <div className={styles.title_group}>
            <h1 className={styles.title}>
              メールマガジンの登録を受け付けました。
              <br className={styles.is_sp} />
            </h1>
            <p className={styles.firsttext}>
              メールマガジンにご登録いただき、ありがとうございます。
              <br />
              ご登録のメールアドレスに登録完了メールを送付しましたので、ご確認ください。
            </p>
            <p className={styles.firsttext}>
              ご登録いただきましたら自動返信メールをお送りいたします。
              <br />
              メールが届いていない場合は「迷惑メール」フォルダに振り分けられている可能性もございます。
              <br />
              受信トレイ以外のフォルダもご確認ください。
              <br />
              それでも届いていない場合は、メールアドレスが正しく登録されていない可能性があります。
              <br />
              お手数ですが、再度ご登録をお願いいたします。
            </p>
          </div>
          <Button text="トップページに戻る" href="/" />
        </div>
      </section>
      <section className={styles.section}>
        <BottomSlider />
      </section>
      <div className={styles.contact}>
        <MailmagazineLink white noGsap />
      </div>
      <div className={styles.column}>
        <Column tagType="h2" />
      </div>
    </article>
  )
}

export default MailmagazineCompleted
